import React, { useState, useEffect } from "react";
import { useLocation, Link } from 'react-router-dom';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, Card, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { formatPrice } from "../utils/formatPrice";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./ProductosDestacados.css";


const baseUrl = process.env.REACT_APP_BASE_URL;

const ProductosDestacados = () => {
    const [productos, setProductos] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    const isHome = location.pathname === "/";
    const isDetalleProducto = location.pathname.startsWith("/productos/");


    // ✅ Obtener productos destacados
    useEffect(() => {
        const fetchDestacados = async () => {
            try {
                const response = await axios.get(`${baseUrl}/productos/destacados`);
                setProductos(response.data.productos);
            } catch (error) {
                console.error("❌ Error al obtener productos destacados:", error);
            }
        };
        fetchDestacados();
    }, []);

    // ✅ Redirigir a la página de detalles
    const handleVerDetalles = (slug) => {
        navigate(`/productos/${slug}`);
    };

    return (
        <div className={`contenedorGeneralDestacados ${isHome ? 'bg-home' : ''} ${isDetalleProducto ? 'bg-detalle' : ''}`}>
            <Container className="productos-destacados">
                <h1 className="text-left mb-4">Productos destacados</h1>

                {productos.length === 0 ? (
                    <p className="text-center">No hay productos destacados por el momento.</p>
                ) : (
                    <div className="swiper-wrapper-outside">
                        <button className="swiper-button-prev-custom">‹</button>
                        <Swiper
                            modules={[Navigation, Pagination]}
                            spaceBetween={20}
                            slidesPerView={1}
                            centeredSlides={false}
                            watchOverflow={true}
                            navigation={{
                                nextEl: ".swiper-button-next-custom",
                                prevEl: ".swiper-button-prev-custom",
                            }}
                            loop={false}
                            rewind={true}
                            pagination={{ clickable: true }}
                            breakpoints={{
                                576: { slidesPerView: 2, centeredSlides: false },
                                768: { slidesPerView: 2, centeredSlides: false },
                                991: { slidesPerView: 3, centeredSlides: false },
                                1200: { slidesPerView: 4, centeredSlides: false }
                            }}
                            className="swiper-container"
                        >

                            {productos.map((producto) => (
                                <SwiperSlide key={producto._id}>
                                    <div
                                        className="producto-card-clickable"
                                        onClick={() => handleVerDetalles(producto.slug)}
                                    >
                                        <Card className="producto-card">
                                            <div className="producto-imagen-container">
                                                {producto.enPromocion && (
                                                    <div className="cartel-promocion">🔥 En promoción</div>
                                                )}

                                                <div className="contImg">
                                                    <Card.Img
                                                        variant="top"
                                                        src={producto.imagen}
                                                        alt={producto.nombre}
                                                        className="producto-imagen"
                                                    />
                                                </div>
                                            </div>
                                            <Card.Body className="productosDestaBody">
                                                <Card.Title className="tituloCardDes">{producto.nombre}</Card.Title>
                                                <Card.Text className="text-muted categoriaDes">
                                                    {producto.categoria?.nombre || "Categoría"}
                                                </Card.Text>
                                                {producto.enPromocion ? (
                                                    <div className="precio-promo-container">
                                                        <span className="precio-tachado">{formatPrice(producto.precio)}</span>
                                                        <span className="precio-promocion">{formatPrice(producto.precioPromocion)}</span>
                                                    </div>
                                                ) : (
                                                    <Card.Text className="producto-precio">{formatPrice(producto.precio)}</Card.Text>
                                                )}

                                                <div className="detalle-destacado-btn-wrap">
                                                    <Button
                                                        className="detalle-destacado-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleVerDetalles(producto.slug);
                                                        }}
                                                    >
                                                        Ver detalle
                                                    </Button>
                                                </div>

                                            </Card.Body>
                                        </Card>
                                    </div>
                                </SwiperSlide>

                            ))}
                        </Swiper>
                        <button className="swiper-button-next-custom">›</button>
                    </div>
                )}
            </Container>
            <div className="d-flex justify-content-center"><Link to={'/productos'} className="sobreW-btn">Ver todos los whiskys</Link></div>
        </div>
    );
};

export default ProductosDestacados;
